<div
  appAddClassModifier
  class="edit-password"
  [class.edit-password_has-dark-background]="hasDarkBackground()"
>
  <div class="edit-password__container">
    @if (formGroupItem) {
      <form
        class="edit-password__form"
        [formGroup]="formGroupItem"
        (ngSubmit)="changePassword()"
      >
        <div class="edit-password__input">
          <app-input
            data-auto-id="oldPassword"
            type="password"
            validate="password"
            [control]="getFormControl('oldPassword')"
            label="Old Password"
          />
        </div>
        <div class="edit-password__input edit-password__input_is-password">
          <app-input
            data-auto-id="password"
            type="password"
            validate="password"
            [control]="getFormControl('password')"
            label="New Password"
          />
        </div>
        <div class="edit-password__input">
          <app-input
            data-auto-id="confirmPassword"
            type="password"
            validate="confirmPassword"
            [control]="getFormControl('confirmPassword')"
            label="Confirm New Password"
          />
        </div>
        <div class="edit-password__button-container">
          <app-button
            data-auto-id="submitFormButton"
            type="submit"
            [label]="submitFormLabel | async"
          />
        </div>
      </form>
    }
  </div>
</div>
